import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

export interface PhotoGalleryItem {
	photoUrl: string;
	caption: string;
}

@Component({
	selector: 'app-photo-gallery',
	templateUrl: './photo-gallery.component.html',
	styleUrls: ['./photo-gallery.component.scss'],
	imports: [MatIcon],
})
export class PhotoGalleryComponent {
	index = 0;

	constructor(@Inject(MAT_DIALOG_DATA) public data: PhotoGalleryItem[]) {}

	navigateLeft(): void {
		if (this.data.length > 0) {
			this.index = (this.index + this.data.length - 1) % this.data.length;
		}
	}

	navigateRight(): void {
		if (this.data.length > 0) {
			this.index = (this.index + 1) % this.data.length;
		}
	}
}
